import { z } from 'zod';

export const cashReportSchema = z.object({
  collections_minor: z.object({ cash: z.number(), card: z.number(), other: z.number() }).optional(),
  state: z.string(), currency: z.string().optional(), label: z.string().optional(),
  opening_minor: z.number().optional(), received_minor: z.number().optional(),
  refunded_minor: z.number().optional(), paid_in_minor: z.number().optional(), paid_out_minor: z.number().optional(),
  expected_minor: z.number().optional(), counted_minor: z.coerce.number().nullable().optional(),
  variance_minor: z.number().nullable().optional(), variance_reason: z.string().nullable().optional(),
  closed_by_user_id: z.number().nullable().optional(),
});
export type CashReport = z.infer<typeof cashReportSchema>;
